import React from "react";
import CardWrapper from "./CardWrapper";

const CardComponent = ({
  id,
  title,
  value,
  content,
  actions,
  children,
  size = "medium",
  shape = "rectangle",
  isDraggable = false,
}) => {
  return (
    <CardWrapper id={id} title={title} size={size} shape={shape} isDraggable={isDraggable}>
      {/* Metric / Value */}
      {value && <div className="text-3xl font-bold text-gray-800 mb-2">{value}</div>}

      {/* Body Content */}
      <div className="mb-4">
        {content || children}
      </div>

      {/* Optional Actions */}
      {actions && <div className="flex justify-end gap-2 mt-4">{actions}</div>}
    </CardWrapper>
  );
};

export default CardComponent;